import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { GateType } from 'modules/gates/types/Gate';

import { getGateType } from 'modules/restrictedAccess/selectors';

import { Modal } from 'components/ui';
import { ModalProps } from 'components/ui/Modal';

import PINCode from './PINCode';
import Relay from './Relay';
import QRCode from './QRCode';

type RestrictedAccessModalContentProps = {
  onCancel?: (event: React.MouseEvent<HTMLButtonElement>) => void,
  onContinue?: (event: React.MouseEvent<HTMLButtonElement>) => void,
};

const CONTENT: { [key in GateType]: React.ElementType<RestrictedAccessModalContentProps> } = {
  [GateType.RELAY]: Relay,
  [GateType.QR_CODE]: QRCode,
  [GateType.PIN_CODE]: PINCode,
};

type RestrictedAccessModalProps = Pick<ModalProps, 'open' | 'onClose'>;

const RestrictedAccessModal: React.FC<RestrictedAccessModalProps> = ({ open, onClose }) => {
  const type = useSelector(getGateType);

  const Content = React.useMemo(() => CONTENT[type], [type]);

  const handleCancel = React.useCallback(() => onClose?.(false), [onClose]);
  const handleContinue = React.useCallback(() => onClose?.(true), [onClose]);

  return (
    <Modal
      open={open}
      hideCloseButton
      className="modal-large"
      title={<FormattedMessage id="restrictedAccess.modal.title" defaultMessage="Blocked by a gate?" tagName="h3" />}
    >
      <div className="flex flex-col gap-l">
        <Content onContinue={handleContinue} onCancel={handleCancel} />
      </div>
    </Modal>
  );
};

export default RestrictedAccessModal;
